import { useCallback } from "react";
import { useSnackbar } from "notistack";
import { setGlobalNotification } from "services/storage";
import { isGCXDomain } from "services/window";

export const useShowSnackbar = () => {
  const { closeSnackbar, enqueueSnackbar } = useSnackbar();

  const addNotification = enqueueSnackbar;

  const addPersistedNotification = useCallback(
    (enqueueSnackbarParams) => {
      isGCXDomain()
        ? setGlobalNotification({ ...enqueueSnackbarParams })
        : enqueueSnackbar({ ...enqueueSnackbarParams });
    },
    [enqueueSnackbar]
  );

  const removeNotification = closeSnackbar;

  return {
    addNotification,
    removeNotification,
    addPersistedNotification
  };
};
